// @ts-nocheck
/* eslint-disable */

"use client";

import {
  Button,
  Column,
  Heading,
  Icon,
  RichText,
  Row,
  Spacer,
} from "tempdev-ds";

import BlockSolutionsTabs from "@/components/blocks/miewtheme/BlockSolutionsTabs/BlockSolutionsTabs";
import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import GravityForm from "@/components/common/GravityForm/GravityForm";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { useGlobalContext } from "@/lib/globalContext";

const ProductsPost = (post: Record<string, unknown>) => {
  const state = useGlobalContext();
  return (
    <div>
      <Spacer height={6} />

      <Row>
        <Column md={12}>
          <Button
            variant="link"
            href="/products/"
            leftIcon={<Icon icon="icon-arrow-back"></Icon>}
            className="mb-4"
          >{state?.dict?.custom?.backSolutions}</Button>
        </Column>
      </Row>

      {!!(post?.blocks as [])?.length &&
        (post?.blocks as []).map((block: BlocksProps, index: number) => {
          return displayBlock(block, index);
        })}

      <Spacer height={8} />

      {post?.extraContent && (
        <Row>
          <Column md={12}>
            <BlockSolutionsTabs
              attrs={{ grid: post?.extraContent, hideNav: true }}
            />
          </Column>
        </Row>
      )}

      {post?.form && (
        <>
          <Spacer height={8} />
          <Row
            align="center"
            mobileSpace={true}
            className="rounded-section"
            style={{ color: "#343A46", backgroundColor: "#EEF9FC" }}
          >
            <Column md={5}>
              <Heading
                tag="h6"
                size="captions"
                className="color-gray50 text-uppercase"
              >
                {state?.dict?.custom?.interested}
              </Heading>
              <Heading tag="h3" size="h2" className="mb-5">{state?.dict?.custom?.moreServices}</Heading>
              <RichText tag="p">{state?.dict?.custom?.contactsTitle}</RichText>
            </Column>
            <Column md={1}></Column>
            <Column md={6}>
              <GravityForm formData={post?.form} formId={process.env.NEXT_PUBLIC_SOLUTIONS_FORM_ID} />
            </Column>
          </Row>
        </>
      )}
      <Spacer height={8} />
    </div>
  );
};
export default ProductsPost;
